import fr from 'facet-rest';
import React from 'react';
import PropTypes from 'prop-types';
import {
  FDImage, FDStack, FDEmphasisSurface,
} from '@facet-wealth/design';

const DescriptionImagePicker = ({ resource }) => {
  return resource.withRelationship(
    fr.relationships.descriptionImage.name,
    (rel) => {
      return (
        <FDEmphasisSurface padding={6} width={'100%'} rounded={false}>
          <FDStack alignItems={'center'} justifyContent={'center'} height={'100%'}>
            <FDImage src={rel.link('related').url()} alt={rel.meta('altText')} maxWidth={'100%'} />
          </FDStack>
        </FDEmphasisSurface>
      );
    },
    () => null,
  );
};

DescriptionImagePicker.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
DescriptionImagePicker.defaultProps = {
};

export default DescriptionImagePicker;
